import React from 'react';
import { Link } from 'react-router-dom';
import Util from '../../../Util';

const PatientAvatar = (props) => {
    return (  
        <h6 className="table-avatar">
            <Link className="avatar avatar-sm mr-2" 
            to={
                    {
                        pathname:'/profile',
                        state: {
                            user: props.patient,
                            userType: 'patient'
                        }
                    }
                }><img className="avatar-img rounded-circle" src={Util.loadImage(props.patient.profileImage)}  alt="User Image" /> </Link>


            <Link 
            to={
                    {
                        pathname:'/profile',
                        state: {
                            user: props.patient,
                            userType: 'patient'
                        }
                    }
                }>{props.patient.firstName} {props.patient.lastName}</Link>
        </h6>
    );
}
 
export default PatientAvatar;